export enum FreelancerOnboardingFormStep {
	MyProfile = 0,
	MyExpertise = 1,
	MySkills = 2,
	MySectors = 3,
	MyPresentation = 4,
	MyAvailability = 5,
	MyProfessionalInformation = 6,
	MyPersonalInformation = 7
}
